<template>
    <div>
        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> published chatbot version
        <strong>{{ $_.get(activity, "payload.version") }}</strong>.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ChatbotPublished",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
